module.exports = __webpack_public_path__ + "files/3436d40e6cae7a88a50aa944b1e06369.png";